import { jsx as _jsx } from "react/jsx-runtime";
import { useFormikContext } from 'formik';
import debounce from 'lodash/debounce';
import lodashGet from 'lodash/get';
import { useRef } from 'react';
import ReactSlider from 'react-slider';
function FormikSlider(props) {
    const { name, debounceTime = 0 } = props;
    const { values, setFieldValue } = useFormikContext();
    const debounceOnChange = useRef(debounce((value) => {
        void setFieldValue(name, value);
    }, debounceTime)).current;
    return (_jsx(ReactSlider, { className: "horizontal-slider", thumbClassName: "thumb", trackClassName: "track", defaultValue: lodashGet(values, name, [0, 100]), onAfterChange: (value) => debounceOnChange(value), renderThumb: (props, state) => (_jsx("div", { ...props, children: _jsx("span", { children: state.valueNow }) })), pearling: true, minDistance: 10 }));
}
export default FormikSlider;
